module.exports = __webpack_public_path__ + "static/media/colorado-symph2.369940c8.png";